import { Form, Modal, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useCreateCompany,
  useGetCompanyDefaultMutation,
} from "../../api/company";
import { useGetDetailRequestMoney } from "../../api/send-money";
import { canCreateNewOrder } from "../../utils/canCreateNewOrder";
import { ReactComponent as CloseIcon } from "../../common/images/svg/CloseIcon.svg";
import { ReactComponent as PrinterIcon } from "../../common/images/svg/Printer.svg";
import CustomBreadCrumb from "../../components/breadCrumb/breadCrumb";
import { useNotification } from "../../components/providers/notification/useNotification";
import { setTitleHeader } from "../../store/use-title-header-store";
import { useBankAccountManagementProvider } from "../../utils/hooks/useBankAccountProvider";
import { useCompany } from "../../utils/hooks/useCompany";
import { useMetadataCompaniesDefault } from "../../utils/hooks/useMetadataCompaniesDefault";
import { useMetadataCountries } from "../../utils/hooks/useMetadataCountries";
import useResponsive from "../../utils/hooks/useResponsive";
import { useWalletManagementProvider } from "../../utils/hooks/useWalletManagementProvider";
import { useReloadSocket } from "../../utils/hooks/useReloadSocket";
import FormAddNewRemitter from "../benificiary-remitter/management/modal-add-new/new-remitter/form-add-new";
import DetailSuccess from "./component/detail-success";
import FormTransfer from "./component/form-transfer";
import "./request-money.css";
import { useAllMetadataCurrency } from '../../utils/hooks/useAllMetadataCurrency'
import FormFutureDate from "./component/form-future-date";

const breadCrumb = [
  {
    name: "Portfolio",
    path: "/",
  },
  {
    name: "Request Money",
    path: "/request-money",
  },
];

const start = 0;
const end = 10;

export const ThemedRequestMoney: React.FC<any> = () => {
  const [formRequestMoney] = Form.useForm();
  const { isTablet } = useResponsive();
  const socket = useReloadSocket();
  const canAction = canCreateNewOrder();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currencyDefault = queryParams.get("currency");
  const navigate = useNavigate();
  const { open: openNotification } = useNotification();
  const hasRunRef = useRef(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [beneficiaryCurrency, setBeneficiaryCurrency] = useState<number | undefined>();
  const [paymentCurrency, setPaymentCurrency] = useState<number | undefined>();
  const [detailRequestMoney, setDetailRequestMoney] = useState<any>(null);
  const [addSender, setAddSender] = useState(false);
  const [infoByUserCodeRemitter, setInfoByUserCodeRemitter] =
    useState<any>(null);
  const [paramsSender, setParamsSender] = useState({ start, end });
  const [senderSelected, setSenderSelected] = useState<any>(null);
  const [actionFutureDate, setActionFutureDate] = useState<boolean>(false);

  const { metadataCountries } = useMetadataCountries();

  const { dataListCompany: dataListSender, refetch } = useCompany(paramsSender);

  const [companyDefaultSelected, setCompanyDefaultSelected] =
    useState<any>(null);

  const [companyDefaultCurrency, setCompanyDefaultCurrency] =
    useState<any>(null);

  const [searchDefaultCompany, setSearchDefaultCompany] = useState<any>();

  const { dataAllCurrency } = useAllMetadataCurrency()

  const { dataCompaniesDefault, isLoading: loadingDefaulCompany } =
    useMetadataCompaniesDefault({
      currencyId: paymentCurrency,
      searchName: searchDefaultCompany,
    });

  const { mutate: getCompanyDefault, isLoading: loadingCompanyCurrency } =
    useGetCompanyDefaultMutation({
      onSuccess: (response: { data: [] }) => {
        setCompanyDefaultCurrency(response?.data);
      },
    });

  const { mutate: getDetailRequestMoney, isLoading: loadingDetail } =
    useGetDetailRequestMoney({
      onSuccess: (response: { data: any }) => {
        setDetailRequestMoney(response?.data);
        setOpenSuccess(true);
      },
      onError: (error: { message: string }) => {
        if (openNotification) {
          openNotification({
            key: "create_failed",
            message: "Something went wrong!",
            type: "error",
          });
        }
      },
    });

  const { mutate: createRemitter, isLoading: loadingCreateRemitter } =
    useCreateCompany({
      onSuccess: (response: { data: { message: string; data: any } }) => {
        if (openNotification) {
          openNotification({
            key: "create_success",
            message: response.data.message || "Create Remitter successfully!",
            type: "success",
          });
        }
        setAddSender(false);
        refetch();
        formRequestMoney?.setFieldsValue({
          sender: response?.data?.data?.id,
        });
      },
      onError: (error: { message: string }) => {
        if (openNotification) {
          openNotification({
            key: "create_failed",
            message: error.message || "Create Remitter failed!",
            type: "error",
          });
        }
      },
    });

  const onSubmitRemitter = (values: any) => {
    if (loadingCreateRemitter) return;
    const body = {
      fullName: values.companyName || "",
      name: values.nickName || "",
      directorFirstName: values.directorFirstName || "",
      directorLastName: values.directorLastName || "",
      address1: values.address1 || "",
      address2: values.address2 || "",
      city: values.city || "",
      stateProvince: values.stateProvince || "",
      country: values.companyOfficiallyRegistered || "",
      tinVatUid: values.tinVatUid || "",
      regNo: values.regNo || "",
      phoneNumber1: values.phoneNumber1 || "",
      email: values.email || "",
      smartUID: values.smartUID ? values.smartUID?.trim() : undefined,
      website: values.website || "",
      postalCode: values.postalCode || "",
      refUserId: infoByUserCodeRemitter?.id
        ? infoByUserCodeRemitter?.id
        : undefined,
    };
    createRemitter(body);
  };

  const handleCloseModalRemitter = () => {
    if (loadingCreateRemitter) return;
    setAddSender(false);
  };

  useEffect(() => {
    if (!paymentCurrency) return;
    getCompanyDefault({ currencyId: paymentCurrency });
  }, [paymentCurrency]);

  const [paramsWalletProvider, setParamsWalletProvider] = useState({
    start,
    end,
  });
  const [searchWalletProvider, setSearchWalletProvider] = useState();
  const [walletSelectedProvider, setWalletSelectedProvider] =
    useState<any>(null);

  const { dataListWalletProvider } = useWalletManagementProvider(
    Number(companyDefaultSelected?.id || 0),
    paramsWalletProvider,
    searchWalletProvider,
    paymentCurrency
  );

  const [paramsBankAccountProvider, setParamsBankAccountProvider] = useState({
    start,
    end,
  });
  const [searchBankAccountProvider, setSearchBankAccountProvider] = useState();
  const [bankAccountSelectedProvider, setBankAccountSelectedProvider] =
    useState<any>(null);

  const { dataListBankAccountProvider } = useBankAccountManagementProvider(
    Number(companyDefaultSelected?.id || 0),
    paramsBankAccountProvider,
    searchBankAccountProvider,
    paymentCurrency
  );

  const handleCancelDetail = () => {
    navigate("/home");
  };

  const handleCancelFutureDate = () => {
    setActionFutureDate(false);
  };

  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;
    if (canAction) setTitleHeader("Request Money");
    else {
      if (openNotification) {
        openNotification?.({
          key: "not_permission",
          message:
            "Your account is currently under review by the admin. You will be able to use this feature once the review is complete and your account is verified.",
          type: "error",
        });
      }
      navigate(`/`);
    }
  }, []);

  // useEffect(() => {
  //   socket.connect();
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, [socket]);

  useEffect(() => {
    if (!detailRequestMoney) return;
    const handleRequestUpdate = () => {
      getDetailRequestMoney(detailRequestMoney?.id);
    };
    socket.on(
      `user.paymentOrders.${detailRequestMoney?.id}.updated`,
      handleRequestUpdate
    );

    return () => {
      socket.off(
        `user.paymentOrders.${detailRequestMoney?.id}.updated`,
        handleRequestUpdate
      );
    };
  }, [socket, detailRequestMoney]);
  useEffect(() => {
    if (!dataAllCurrency?.length) return
    const beneficiaryCurrency = currencyDefault ?? 'USD';
    const beneficiaryCurrencyDefault = dataAllCurrency.find((item: any) => item.symbol === beneficiaryCurrency) as any;
    // const paymentCurrencyDefault = dataAllCurrency.find((item: any) => item.symbol === 'EUR') as any;
    const beneficiaryCurrencyId = beneficiaryCurrencyDefault?.id;
    // const paymentCurrencyId = paymentCurrencyDefault?.id;
    setBeneficiaryCurrency(beneficiaryCurrencyId)
    setPaymentCurrency(beneficiaryCurrencyId)
  }, [dataAllCurrency])

  return (
    <div className="request-money-container">
      <CustomBreadCrumb breadCrumb={breadCrumb} showHome={true} />
      <FormTransfer
        form={formRequestMoney}
        beneficiaryCurrency={beneficiaryCurrency}
        setBeneficiaryCurrency={setBeneficiaryCurrency}
        paymentCurrency={paymentCurrency}
        setPaymentCurrency={setPaymentCurrency}
        companyDefaultSelected={companyDefaultSelected}
        setCompanyDefaultSelected={setCompanyDefaultSelected}
        companyDefaultCurrency={companyDefaultCurrency}
        dataCompaniesDefault={dataCompaniesDefault}
        loadingDefaulCompany={loadingDefaulCompany}
        loadingCompanyCurrency={loadingCompanyCurrency}
        setSearchDefaultCompany={setSearchDefaultCompany}
        paramsWalletProvider={paramsWalletProvider}
        setParamsWalletProvider={setParamsWalletProvider}
        walletSelectedProvider={walletSelectedProvider}
        setWalletSelectedProvider={setWalletSelectedProvider}
        dataListWalletProvider={dataListWalletProvider}
        paramsBankAccountProvider={paramsBankAccountProvider}
        setParamsBankAccountProvider={setParamsBankAccountProvider}
        bankAccountSelectedProvider={bankAccountSelectedProvider}
        setBankAccountSelectedProvider={setBankAccountSelectedProvider}
        dataListBankAccountProvider={dataListBankAccountProvider}
        dataListSender={dataListSender}
        paramsSender={paramsSender}
        setParamsSender={setParamsSender}
        senderSelected={senderSelected}
        setSenderSelected={setSenderSelected}
        getDetailRequestMoney={getDetailRequestMoney}
        loadingDetail={loadingDetail}
        setAddSender={setAddSender}
        dataAllCurrency={dataAllCurrency}
      />
      <Modal
        open={!!openSuccess}
        onCancel={handleCancelDetail}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <Typography
                style={{ fontSize: 20, fontWeight: 700, color: "#C2C6CE" }}
              >
                {`Order Submitted Successfully`}
              </Typography>
              <PrinterIcon
                className="icon-animation"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(detailRequestMoney?.printableFormUrl, "_blank")
                }
              />
            </div>
            <CloseIcon
              onClick={handleCancelDetail}
              style={{ cursor: "pointer" }}
            />
          </>
        }
        className="send-money-modal"
      >
        <DetailSuccess detailRequestMoney={detailRequestMoney} setActionFutureDate={setActionFutureDate} />
      </Modal>
      <Modal
        open={!!addSender}
        onCancel={handleCloseModalRemitter}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <Typography
              style={{
                fontSize: isTablet ? 16 : 20,
                fontWeight: 700,
                color: "#C2C6CE",
              }}
            >
              {"Add Remitter"}
            </Typography>
            <CloseIcon
              onClick={handleCloseModalRemitter}
              className="icon-animation"
            />
          </>
        }
        className="add-beneficiary-modal"
      >
        <div className="add-beneficiary-modal-body">
          <FormAddNewRemitter
            onSubmitInfo={onSubmitRemitter}
            metadataCountries={metadataCountries}
            setInfoByUserCode={setInfoByUserCodeRemitter}
            infoByUserCode={infoByUserCodeRemitter}
          />
        </div>
      </Modal>
      <Modal
        open={actionFutureDate}
        onCancel={handleCancelFutureDate}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <Typography
              style={{
                fontSize: isTablet ? 16 : 20,
                fontWeight: 700,
                color: "#C2C6CE",
              }}
            >
              {"Future date"}
            </Typography>
            <CloseIcon onClick={handleCancelFutureDate} className="icon-animation" />
          </>
        }
        className="edit-wallet-modal"
      >
        <FormFutureDate
          detailRequestMoney={detailRequestMoney}
          form={formRequestMoney}
          handleCancel={handleCancelFutureDate}
          id={detailRequestMoney?.id}
        />
      </Modal>
    </div>
  );
};
